import { z } from 'zod';

export const GetEtymologyResponseSchema = z.object({
  etymology: z.string().min(1, 'Etymology cannot be empty'),
  relatedWords: z.array(z.string()),
});

export type IGetEtymologyResponseDto = z.infer<
  typeof GetEtymologyResponseSchema
>;
